var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomer = function SvgCustomer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9997 5.33333C17.4142 5.33333 18.7707 5.89523 19.7709 6.89543C20.7711 7.89562 21.333 9.25217 21.333 10.6667C21.333 12.0811 20.7711 13.4377 19.7709 14.4379C18.7707 15.4381 17.4142 16 15.9997 16C14.5852 16 13.2286 15.4381 12.2284 14.4379C11.2282 13.4377 10.6663 12.0811 10.6663 10.6667C10.6663 9.25217 11.2282 7.89562 12.2284 6.89543C13.2286 5.89523 14.5852 5.33333 15.9997 5.33333ZM15.9997 18.6667C21.893 18.6667 26.6663 21.0533 26.6663 24V26.6667H5.33301V24C5.33301 21.0533 10.1063 18.6667 15.9997 18.6667Z",
    fill: "inherit"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "customer.fd8b7c816c028f10fd2aac397a561f3a.svg";